/*
 Handle the bindings on our minicalcs
 */

import MiniCalculatorPage from "pages/mini-calculators/components/MiniCalculatorPage";

export default {
    extends: {
        methods: {
            ...MiniCalculatorPage.methods
        },
        computed: {
            ...MiniCalculatorPage.computed
        }
    },
    methods: {
        hidePrompt() {
            const summary = document.querySelector('.p-animated-calc__summary-panel');
            const results = document.querySelector('.p-animated-calc__results-panel');
            const share = document.querySelector('.p-animated-calc__share');

            summary.style.display = 'none';
            results.style.opacity = '1';
            share.style.display = 'block';
        },
        showPrompt() {
            const summary = document.querySelector('.p-animated-calc__summary-panel');
            const results = document.querySelector('.p-animated-calc__results-panel');
            const share = document.querySelector('.p-animated-calc__share');

            summary.style.display = 'block';
            results.style.opacity = '0';
            share.style.display = 'none';
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/mini-calculators/calculators/mixins/MiniCalculatorBindings.js